<div>
    <div class="links">
    </div>
    <hr />
    <div class="copy">
        &copy; Copyright 2022 www.skillsclub.com <span>|</span> All rights reserved
    </div>
</div>